export const VALIDATION_STATUSES = [
	"Verified",
	"Matched with Issues",
	"Unconfirmed",
	"Data Mismatch",
	"Missing in TeleTrace",
	"Unable to Validate",
];

export const SUMMARY_METRICS = [
	{ key: "totalEhrVisits", label: "Total EHR Visits", status: "" },
	{ key: "verified", label: "Verified", status: "Verified" },
	{ key: "matchedWithIssues", label: "Matched with Issues", status: "Matched with Issues" },
	{ key: "unconfirmed", label: "Unconfirmed", status: "Unconfirmed" },
	{ key: "dataMismatch", label: "Data Mismatch", status: "Data Mismatch" },
	{ key: "missingInTeleTrace", label: "Missing in TeleTrace", status: "Missing in TeleTrace" },
	{ key: "unableToValidate", label: "Unable to Validate", status: "Unable to Validate" },
];

export const formatUploadTimestamp = (value) => {
	if (!value) return null;
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return null;
	return date.toLocaleString("en-US", {
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
		month: "short",
		year: "numeric",
	});
};

export const formatUploadDateRange = (start, end) => {
	if (!start && !end) return null;
	const format = (value) => {
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return value;
		return date.toLocaleDateString("en-US", {
			day: "numeric",
			month: "short",
			year: "numeric",
		});
	};
	if (start && end) return `${format(start)} – ${format(end)}`;
	return format(start || end);
};

export const getValidationStatusLabel = (status) => status;

export const formatValidationFlagLabel = (count) => {
	if (!count) return "—";
	return count === 1 ? "1 Flag" : `${count} Flags`;
};

export const formatUploadBannerTimestamp = (value) => {
	if (!value) return null;
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return null;
	const datePart = date.toLocaleDateString("en-US", {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
	const timePart = date.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "2-digit",
	});
	return `${datePart} · ${timePart}`;
};

export const getValidationStatusClass = (status) => {
	switch (status) {
		case "Verified":
			return "statusVerified";
		case "Matched with Issues":
			return "statusIssues";
		case "Unconfirmed":
			return "statusUnconfirmed";
		case "Data Mismatch":
			return "statusMismatch";
		case "Missing in TeleTrace":
			return "statusMissing";
		case "Unable to Validate":
			return "statusUnable";
		default:
			return "statusNeutral";
	}
};

export const buildValidationQueryParams = ({
	currentPage,
	dateRange,
	debouncedSearch,
	endDate,
	organizationId,
	providerFilter,
	rowsPerPage,
	startDate,
	statusFilter,
	uploadId,
}) => {
	const params = {
		limit: rowsPerPage,
		page: currentPage,
		...(organizationId ? { organizationId } : {}),
		...(debouncedSearch ? { search: debouncedSearch } : {}),
		...(statusFilter ? { status: statusFilter } : {}),
		...(providerFilter ? { providerId: providerFilter } : {}),
		...(uploadId ? { uploadId } : {}),
	};

	if (dateRange) {
		params.dateRange = dateRange;
		if (dateRange === "custom") {
			if (startDate) params.startDate = startDate;
			if (endDate) params.endDate = endDate;
		}
	}

	return params;
};

export const hasActiveValidationFilters = ({
	dateRange,
	debouncedSearch,
	endDate,
	providerFilter,
	startDate,
	statusFilter,
	uploadId,
}) =>
	Boolean(
		debouncedSearch ||
			statusFilter ||
			providerFilter ||
			dateRange ||
			startDate ||
			endDate ||
			uploadId,
	);
